export default function Divider() {
  return (
    <div className="relative w-full md:h-12 h-6 overflow-hidden bg-transparent"></div>
  );
}
